export default "__VITE_ASSET__CxUN$v6j__"